/** FPL's fixed starting budget: every new team starts on £100m. */
export const TEAM_BUDGET_MILLIONS = 100;

/**
 * The most a hand-built squad may cost and still be rated. Prices drift over
 * the season, so a squad copied from a real team (the template team included)
 * routinely sits a few tenths above £100m; refusing it there was a dead end
 * for a visitor who had done nothing wrong. Over budget is shown, not blocked,
 * until this ceiling.
 */
export const TEAM_BUDGET_CEILING_MILLIONS = 105;

export type TeamBudgetAssessment = {
  /** Above the £100m a new team gets: shown in red, still rateable. */
  isOverBudget: boolean;
  /** Above the leeway ceiling: continue is blocked. */
  isOverCeiling: boolean;
};

const TENTHS = 10;

/** Rounds to the tenth the bank line displays, so float accumulation in the price sum cannot block a squad whose shown value is on budget. */
export const roundToDisplayedTenth = (value: number): number =>
  Math.round(value * TENTHS) / TENTHS;

export const assessTeamBudget = (totalValue: number): TeamBudgetAssessment => {
  const displayed = roundToDisplayedTenth(totalValue);
  return {
    isOverBudget: displayed > TEAM_BUDGET_MILLIONS,
    isOverCeiling: displayed > TEAM_BUDGET_CEILING_MILLIONS
  };
};
